import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useFormik } from "formik";
import toast from "react-hot-toast";

import "../Asociados/createAsociados.css";
import "./createOrden.css";
import { selectBonificacionFormValidation } from "../../../../helper/validate";

import * as api from "helper/helper";
import "./../formsCommons.css";

import {
  buildNameWithId,
  onlyNumbers,
  onlyNumbersFloat,
  Singleton,
} from "helper/tools";
import invalidClass from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import AutocompleteGo from "../Autocomplete/AutocompleteGo";

const SelectBonificacion = forwardRef(
  (
    {
      item,
      onChange,
      returnToModalId,
      isAsociadoSeleccionado,
      isClienteSeleccionado,
    },
    ref,
  ) => {
    const modalRef = useRef();
    const dismissBtnRef = useRef();

    const refAutocompleteAsociados = useRef(null);

    const targetReturnToModalId = `#${returnToModalId}`;

    /// CHECAR  useTraceUpdate(props, "CreateOrdenVenta");
    const [initialValues, setInitialValues] = useState({
      id: 0,
      promocionId: 0,
      valuePercent: 0,
      amountDiscount: 0,
      precioUnitario: 0,
      precioNuevo: 0,

      totalMin: 0,
      totalMax: 90,
      newTotal: 0,
    });
    /*{
      id: 0,
      promocionId: 0,
      valuePercent: 0,
      amountDiscount: 0,
      precioUnitario: 0,
      precioNuevo: 0,

      totalMin: 0,
      totalMax: 90,
      newTotal: 0,
    });*/
    const [isActiveDisabled, setIsActiveDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [bonificaciones, setBonificaciones] = useState([]);
    const [promocion, setPromocion] = useState(null);

    const [nuevoTotal, setNuevoTotal] = useState(0);
    const [porcentajeDescuento, setPorcentajeDescuento] = useState(0);

    const [errorPrecioNuevo, setErrorPrecioNuevo] = useState(false);
    const [errorPrecioNuevoMessage, setErrorPrecioNuevoMessage] = useState("");

    //const [newTotal, setNewTotal] = useState(0);
    //const createMode = item?.promocion?.id ? item.promocion.id === 0 : true;
    const createMode = (item?.bonificacion?.promocion?.id ?? 0) === 0;
    //item?.promocion?.id ? item.promocion.id === 0 : true;

    useEffect(() => {
      console.log("---> change item: " + item);
      let isActiveDisable = createMode;
      setIsActiveDisabled(isActiveDisable);

      //- GONEsetPromocion(null);
      formik?.resetForm();

      /*const newInitialValues = buildInitialValues();
      setInitialValues(newInitialValues);*/
      setInitialValues({
        id: 0,
        promocionId: 0,
        valuePercent: 0,
        amountDiscount: 0,
        precioUnitario: 0,
        precioNuevo: 0,

        totalMin: 0,
        totalMax: 90,
        newTotal: 0,
      });

      fetchData();

      if (item == null) {
        return;
      }

      //control defaults
      /*formik.setFieldValue(
        "precioUnitario",
        Singleton.getInstance2().format(item.producto.precio),
      );
      formik.setFieldValue("precioNuevo", 0);*/

      formik.setValues({
        ...formik.values,
        totalMin: (item.producto.precio * 0.1).toFixed(0).toString(),
        totalMax: (item.producto.precio * 0.9).toFixed(0).toString(),
      });
    }, [item]);

    useEffect(() => {}, [nuevoTotal]);

    //let tags = null;

    const fetchData = async () => {
      /*
      debe estar seleccionado de perdida asociado
      */
      if (!isAsociadoSeleccionado && !isClienteSeleccionado) {
        setBonificaciones([]);
        return;
      }

      setIsLoading(true);
      const response = await api.promociones().catch((e) => {
        toast.error("Error al pedir bonificaciones. ");
      });
      setIsLoading(false);
      if (!response) return;

      const autoBonificaciones = response.data
        .map((info) => {
          /*
          bonificacion no esta activa no incluir
          */
          if (!info.activo || !info.ver) return null;

          const text = buildNameWithId(info, info.numAsociado);

          if (
            info.promocionDetalles == null ||
            info.promocionDetalles?.length === 0
          ) {
            return null;
          }

          const promoDetalle = info.promocionDetalles[0];
          let isEnabled = false;
          if (
            (isAsociadoSeleccionado && !isClienteSeleccionado) ||
            (isAsociadoSeleccionado &&
              isClienteSeleccionado &&
              !promoDetalle.exclusivoAsociado)
          ) {
            isEnabled = true;
          }

          /*  if (!isEnabled) {
            /*
          2 beneficio colaborador, selecciona:
          - asociado como empleado
          - sin cliente
          * /
            isEnabled =
              info.id === 2 &&
              (item?.asociado?.info?.empleado ?? false) &&
              item?.cliente == null;

            if (
              !isEnabled &&
              [6].includes(info.id) &&
              item?.asociado != null &&
              item?.cliente == null
            ) {
              const promocionDetalle = info.promocionDetalles[0];

              const paraAsociadoId = promocionDetalle.asociado?.id;
              isEnabled = item?.asociado.id === paraAsociadoId;
            }
          }*/

          if (!isEnabled) {
            /*
          4 regalo en compra
          - siempre
          */
            isEnabled = info.id === 4;
          }
          /** */
          if (!isEnabled) {
            return null;
          }

          return { id: info.id, nombre: text, info: info, enabled: isEnabled };
        })
        .filter(Boolean);

      setBonificaciones(autoBonificaciones);

      const newInitialValues = buildInitialValues();
      setInitialValues(newInitialValues);

      /* if (!createMode) {
        // load product info & selected bonificacion
        const promocionId = item?.bonificacion?.promocion?.id;
        const found = autoBonificaciones.find(
          (info) => info.id === promocionId,
        );
        if (found != null) {
          const newPromocion = found.info;
          setPromocion(newPromocion);

          //
          if (
            newPromocion.editar
            //newItem?.promocion?.id === PROMOCIONES_STATES.VENTA_INTERNA.id
          ) {
            const { promoConfig } = item.bonificacion;
            formik.setValues({
              valuePercent: promoConfig.descuentoPorcentaje,
              precioNuevo: Singleton.getInstance2().format(
                promoConfig.nuevoTotal,
              ),
            });
          }
        }
      }*/

      console.log(response.status);
    };

    useEffect(() => {
      formik?.resetForm();

      //fetchData();

      //    const newPermissions = PermissionsForSection(Sections.Clientes);
      //  setPermissions(newPermissions);
    }, []);

    useEffect(() => {
      const valuePer = porcentajeDescuento.toFixed(0);

      formik.setFieldValue(
        "valuePercent",
        //  Singleton.getInstance2().format(nuevoPrecio)
        valuePer,
      );
    }, [porcentajeDescuento]);

    // initial
    function buildInitialValues() {
      let aAmountDiscount = 0;
      let unitario = 0;
      let aValuePercent = 40; // enviar el valor de descuento en ventainterna
      const bonificacion = item?.bonificacion;
      if (bonificacion?.promocion?.editar) {
        const promoConfig = bonificacion?.promoConfig;
        aValuePercent = promoConfig?.descuentoPorcentaje;

        setPorcentajeDescuento(aValuePercent);

        aValuePercent = aValuePercent.toFixed(0);

        aAmountDiscount = Singleton.getInstance2().format(
          promoConfig?.nuevoTotal,
        );
        unitario = Singleton.getInstance2().format(item.producto.precio);
      }

      /*
       id: 0,
      promocionId: 0,
      valuePercent: 0,
      amountDiscount: 0,
      precioUnitario: 0,
      precioNuevo: 0,

      totalMin: 0,
      totalMax: 90,
      newTotal: 0,
      */

      return {
        id: 0,
        promocionId: bonificacion?.promocion?.id || 0,
        valuePercent: aValuePercent || 0,
        amountDiscount: 0,
        precioUnitario: unitario || 0,
        precioNuevo: aAmountDiscount || 0,

        totalMin: 0,
        totalMax: 90,
        newTotal: 0,
      };
    }

    //const initialValues = buildInitialValues();

    /*let initialValues = {
      id: 0,

      promocionId: 0,
      valuePercent: 0,
      amountDiscount: 0,
      precioUnitario: 0,
      precioNuevo: 0,
    };*/

    //console.log("-->");
    //console.log(initialValues);

    const formik = useFormik({
      initialValues,
      enableReinitialize: true,
      validate: selectBonificacionFormValidation,
      validateOnBlur: false,
      validateOnChange: false,
      onSubmit: async (values, { props, setSubmitting }) => {},
    });

    useImperativeHandle(ref, () => ({
      getValue: () => {
        return formik.values;
      },
      toggleModal: () => {
        //setValuePercent(null);

        formik?.resetForm();
        modalRef.current.click();
      },
    }));

    useEffect(() => {
      console.log(
        ">>>> formik.values.promocionId: " + formik.values.promocionId,
      );
      let newPromocion = null;
      const promocionId = formik.values.promocionId;
      if (promocionId == null || promocionId !== 0) {
        newPromocion = bonificaciones.find((e) => e.id === promocionId);
      }

      /*
       es diferente al inicial
       cargar sus defaults si es editar
       */
      let unitario = 0;
      let aValuePercent = 0,
        rawValuePercent = 0;
      let aAmountDiscount = 0;
      let precioNuevo = 0;
      if (promocionId === item?.bonificacion?.promocion?.id) {
        if (item?.bonificacion?.promocion?.editar) {
          // unitario = 0;
          aValuePercent = 40; // enviar el valor de descuento en ventainterna

          const bonificacion = item?.bonificacion;
          const promoConfig = bonificacion?.promoConfig;
          aValuePercent = promoConfig?.descuentoPorcentaje;
          rawValuePercent = aValuePercent;

          precioNuevo = Singleton.getInstance2().format(
            promoConfig?.nuevoTotal,
          );

          //setPorcentajeDescuento(aValuePercent);

          aValuePercent = aValuePercent.toFixed(0);

          aAmountDiscount = Singleton.getInstance2().format(
            promoConfig?.nuevoTotal,
          );
          unitario = Singleton.getInstance2().format(item.producto.precio);
        }
      } else if (newPromocion?.info.promocionDetalles?.length > 0) {
        const promo = newPromocion?.info.promocionDetalles?.[0];
        //const promoConfig = bonificacion?.promoConfig;

        const minMaxInfo = minMaxDescuento(promo);
        precioNuevo = Singleton.getInstance2().format(minMaxInfo.priceDefault);

        aValuePercent = promo.descuento;
        rawValuePercent = aValuePercent;
        /*    aAmountDiscount = Singleton.getInstance2().format(
          promoConfig?.nuevoTotal,
        ); */
        unitario = Singleton.getInstance2().format(item.producto.precio);
      }

      /*
      cargar defaults para que no entre en estado invalido
      */

      formik.setValues({
        ...formik.values,
        valuePercent: aValuePercent,
        precioUnitario: unitario,
        precioNuevo: precioNuevo,
      });

      setPromocion(newPromocion?.info);

      // calculateTotal(rawValuePercent);
    }, [formik.values.promocionId]);

    function updatePrecioNuevo(newTotal) {
      formik.setFieldValue("precioNuevo", newTotal.toFixed(2));

      calculateTotalByAmount(newTotal);
    }

    /*useEffect(() => {
      console.log("-->PROMOCION:  ", promocion);
      if (promocion?.editar) {
        const descuento = promocion.promocionDetalles[0].descuento;
        formik.setFieldValue("valuePercent", descuento);

        //setValuePercent(descuento);

        //calculateTotal();
      }
    }, [promocion]);*/

    function calculateTotal(valuePer) {
      //const valuePer = formik.values.valuePercent; //parseInt(valuePercent); //formik.values.valuePercent);
      if (Number.isNaN(valuePer) || item == null) {
        console.log("__ valuePercent NOT valid");
        return;
      }
      let nuevoPrecio = item.producto.precio * ((100 - valuePer) / 100);
      nuevoPrecio = Number.parseFloat(nuevoPrecio.toFixed(2));

      formik.setFieldValue(
        "precioNuevo",
        Singleton.getInstance2().format(nuevoPrecio),
      );
      console.log("---> 2 " + nuevoPrecio);
    }

    function calculateTotalByAmount(newTotal) {
      const valueAmount = Number.parseInt(newTotal); //formik.values.valuePercent);
      if (Number.isNaN(valueAmount) || item == null) {
        console.log("__ valueAmount NOT valid");
        return;
      }
      //const nuevoPrecio = item.producto.precio * ((100 - valuePer) / 100);

      /*nuevoPrecio = item.producto.precio * ((100 - valuePer) / 100);
      nuevoPrecio/item.producto.precio = (100 - valuePer) / 100;
      nuevoPrecio/item.producto.precio *100 = 100 - valuePer ;
      (nuevoPrecio/item.producto.precio *100)-100 = - valuePer ;*/
      let valuePer = 100 - (valueAmount / item.producto.precio) * 100;

      setPorcentajeDescuento(valuePer);
    }

    function minMaxDescuento(detalles) {
      const valueMin =
        detalles.minimoDescuento == null || detalles.minimoDescuento < 10
          ? 10
          : detalles.minimoDescuento;
      const valueMax =
        detalles.maximoDescuento == null || detalles.maximoDescuento > 90
          ? 90
          : detalles.maximoDescuento;
      const valueDefault =
        detalles.descuento == null || detalles.descuento > 90
          ? 40
          : detalles.descuento;

      //  let nuevoPrecio = item.producto.precio * ((100 - valuePer) / 100);
      const priceMin = ((100 - valueMin) / 100) * item.producto.precio;
      const priceMax = ((100 - valueMax) / 100) * item.producto.precio;
      const priceDefault = ((100 - valueDefault) / 100) * item.producto.precio;

      return { priceMin, priceMax, priceDefault };
    }

    function handleSubmit(event) {
      event.preventDefault();
    }

    function showNuevoTotalErrorNotice(show, message = "") {
      setErrorPrecioNuevo(show);
      setErrorPrecioNuevoMessage(message);

      if (show === false) {
        return;
      }

      setTimeout(() => {
        setErrorPrecioNuevo(false);
      }, 3000);
    }

    console.log("--> CREATEORDEN Draw " + formik.values.precioNuevo);

    const detalles = promocion?.promocionDetalles
      ? promocion?.promocionDetalles[0]
      : null;
    /*if (
      promocion?.promocionDetalles == null ||
      promocion?.promocionDetalles?.length === 0
    ) {
      console.log("--> PROMO ERROR: ");
    }

    const detalles = promocion?.promocionDetalles[0];*/
    console.log("--> PROMO ID : " + formik.values.promocionId);
    console.log("--> PROMO : " + JSON.stringify(promocion));
    console.log("--> PROMO EDITAR: " + promocion?.editar);

    return (
      <>
        <button
          ref={modalRef}
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdropSelectBonifica"
          hidden
        >
          Abrir Crear Orden
        </button>

        <div
          className="modal fade modal-lg"
          id="staticBackdropSelectBonifica"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropSelectBonificaLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="staticBackdropSelectBonificaLabel"
                >
                  Selecciona Bonificación
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  data-bs-toggle="modal"
                  data-bs-target={targetReturnToModalId}
                  aria-label="Close"
                ></button>
              </div>

              <div
                className="modal-body"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <form className="row g-3" onSubmit={handleSubmit}>
                  <div className="form-control">
                    <div className="container d-grid gap-3">
                      <div className="col align-self-start">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Nombre
                        </label>
                        {isLoading && (
                          <div className="animate-pulse">
                            <div></div>
                          </div>
                        )}
                        {!isLoading && (
                          <AutocompleteGo
                            ref={refAutocompleteAsociados}
                            options={bonificaciones}
                            placeholder="Buscar bonificación..."
                            className={`form-select ${invalidClass(
                              formik.errors.promocionId,
                            )}`}
                            value={formik.values.promocionId}
                            onChange={(e) => {
                              if (e == null) {
                                formik.setFieldValue("promocionId", 0);
                                //-GONE setPromocion(null);
                                return;
                              }

                              formik.setFieldValue("promocionId", e.id);

                              //const info = e.option.info;
                              //-GONE setPromocion(info);

                              /*
                            venta interna
                            */
                              /*if (info.editar) {
                              const descuento =
                                info.promocionDetalles[0].descuento;
                              //formik.setFieldValue("valuePercent", descuento);

                              setValuePercent(descuento);

                              //calculateTotal();
                            }*/
                              console.log(e);
                            }}
                            readOnly={false}
                          >
                            <div className="valid-feedback">Looks good!</div>
                            <div className="invalid-feedback">
                              {formik.errors.promocionId}
                            </div>
                          </AutocompleteGo>
                        )}
                      </div>

                      {isLoading && (
                        <div className="row">
                          <div className="col animate-pulse"></div>
                          <div className="col animate-pulse"></div>
                          <div className="col animate-pulse"></div>
                        </div>
                      )}
                      {!isLoading && promocion?.editar && (
                        <div className="row">
                          <div className="col">
                            <div className="input-group mb-3">
                              <div className="form-floating">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="floatingInputGroup1"
                                  placeholder="Username"
                                  min={detalles.minimoDescuento}
                                  step="1"
                                  value={formik.values.valuePercent}
                                  max={detalles.maximoDescuento}
                                  onInput={(e) => {
                                    e.currentTarget.focus();

                                    let value = Number.parseInt(
                                      e.currentTarget.value,
                                    );
                                    //--
                                    let newMaxValue = value;
                                    if (Number.isNaN(value)) {
                                      newMaxValue = detalles.minimoDescuento;
                                    } else if (
                                      newMaxValue > detalles.maximoDescuento
                                    ) {
                                      newMaxValue = detalles.maximoDescuento;
                                    } else if (
                                      newMaxValue < detalles.minimoDescuento
                                    ) {
                                      newMaxValue = detalles.minimoDescuento;
                                    }
                                    //---
                                    setPorcentajeDescuento(newMaxValue);

                                    calculateTotal(newMaxValue);
                                  }}
                                  disabled={false}
                                />
                                <label htmlFor="floatingInputGroup1">
                                  Porcentaje Descuento
                                </label>
                              </div>
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                          <div className="col">
                            <div className="input-group mb-3">
                              <span className="input-group-text">$</span>
                              <div className="form-floating">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="floatingInputGroup2"
                                  placeholder="Username"
                                  style={{ textAlign: "center" }}
                                  value={formik.values.precioUnitario}
                                  max={90}
                                  onInput={(e) => {
                                    formik.setFieldValue(
                                      "precioUnitario",
                                      e.currentTarget.value,
                                    );
                                    //
                                    /*    updateProduct(
                                                  index,
                                                  parseInt(
                                                    e.currentTarget.value
                                                  )
                                                );*/
                                  }}
                                  disabled={true}
                                />
                                <label htmlFor="floatingInputGroup2">
                                  Precio Unitario
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col">
                            <div className="input-group mb-3">
                              <span className="input-group-text">$</span>
                              <div className="form-floating">
                                <input
                                  type="text"
                                  className={`form-control ${invalidClass(errorPrecioNuevo)}`}
                                  id="floatingInputGroup3"
                                  placeholder="Nuevo Total"
                                  style={{ textAlign: "center" }}
                                  value={formik.values.precioNuevo}
                                  min={formik.values.totalMin}
                                  step="1"
                                  max={formik.values.totalMax}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "precioNuevo",
                                      e.currentTarget.value,
                                    );
                                  }}
                                  onBlur={(e) => {
                                    let aValue = onlyNumbersFloat(
                                      e.target.value,
                                    );
                                    let value = Number.parseFloat(aValue);

                                    /*
                                    const valueMin =
                                      detalles.minimoDescuento == null ||
                                      detalles.minimoDescuento < 10
                                        ? 10
                                        : detalles.minimoDescuento;
                                    const valueMax =
                                      detalles.maximoDescuento == null ||
                                      detalles.maximoDescuento > 90
                                        ? 90
                                        : detalles.maximoDescuento;

                                    //  let nuevoPrecio = item.producto.precio * ((100 - valuePer) / 100);
                                    const priceMin =
                                      ((100 - valueMin) / 100) *
                                      item.producto.precio;
                                    const priceMax =
                                      ((100 - valueMax) / 100) *
                                      item.producto.precio;
                                      */

                                    const minMaxInfo =
                                      minMaxDescuento(detalles);

                                    let showMessage = false;
                                    if (Number.isNaN(value)) {
                                      showNuevoTotalErrorNotice(
                                        true,
                                        "Mostrando valor mínimo",
                                      );
                                      updatePrecioNuevo(minMaxInfo.priceMin);
                                      return;
                                    }
                                    /* must be between 10 to 90 %
                                      min={formik.values.totalMin}
                                  step="1"
                                  max={formik.values.totalMax}
                                  */
                                    if (
                                      //value < item.producto.precio * 0.01 ||
                                      value > minMaxInfo.priceMin
                                    ) {
                                      value = minMaxInfo.priceMin;
                                      showMessage = true;
                                    } else if (value < minMaxInfo.priceMax) {
                                      value = minMaxInfo.priceMax;
                                      showMessage = true;
                                    }

                                    if (showMessage) {
                                      const nueviValorTotalMessage = `Nuevo Total debe ser entre ${Singleton.getInstance().format(minMaxInfo.priceMax)} y ${Singleton.getInstance().format(minMaxInfo.priceMin)}`;
                                      showNuevoTotalErrorNotice(
                                        true,
                                        nueviValorTotalMessage,
                                      );
                                    }

                                    updatePrecioNuevo(value);
                                    console.log("---> " + value);
                                    //formik.setFieldValue("precioNuevo", aValue);
                                  }}
                                  disabled={false}
                                />
                                <label htmlFor="floatingInputGroup3">
                                  Nuevo Total
                                </label>
                                <div className="invalid-tooltip goerror">
                                  {errorPrecioNuevoMessage}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-toggle="modal"
                      data-bs-dismiss="modal"
                      data-bs-target={targetReturnToModalId}
                    >
                      Cancelar
                    </button>
                    <button
                      ref={dismissBtnRef}
                      className="btn btn-primary"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-dismiss="modal"
                      data-bs-target={targetReturnToModalId}
                      hidden
                    ></button>

                    <LoadingButton
                      style={{ height: "38px" }}
                      onClick={(e) => {
                        formik.handleSubmit();
                        dismissBtnRef.current.click();

                        if (promocion == null) {
                          onChange?.(item);
                          return;
                        }

                        // enviar el valor de descuento en ventainterna
                        /*
                          promoConfig.descuentoPorcentaje,
        );
        aAmountDiscount = Singleton.getInstance2().format(
          promoConfig.nuevoTotal,
          */

                        let promoConfig = {};
                        if (
                          promocion.editar
                          //promocion.id === PROMOCIONES_STATES.VENTA_INTERNA.id
                        ) {
                          promoConfig.descuentoPorcentaje = Number.parseFloat(
                            onlyNumbers(porcentajeDescuento),
                          );
                          //promoConfig.descuentoPorcentaje = promoConfig.descuentoPorcentaje.toFixed(2);

                          promoConfig.nuevoTotal = Number.parseFloat(
                            onlyNumbersFloat(formik.values.precioNuevo),
                          );
                        }

                        console.log(promoConfig);

                        onChange?.(item, { promocion, promoConfig });
                      }}
                      text={"Guardar"}
                      loadingText={"Guardando..."}
                      isLoading={isLoading}
                      isDisable={createMode && formik.values.promocionId <= 0}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default SelectBonificacion;
